import { useCallback } from 'react';
import { updateVehicle } from '../api/vehicleService';
import type { Vehicle } from '../types';

interface UseVehicleStatusUpdateOptions {
  userId: string | number;
  onOptimisticUpdate: (vehicle: Vehicle, updatedVehicle: Vehicle) => void;
  onRevert: (vehicle: Vehicle) => void;
  onSuccess: (vehicle: Vehicle, statusId: any) => void;
  onError: (vehicle: Vehicle, error: unknown) => void;
}

/**
 * useVehicleStatusUpdate
 *
 * 車両ステータス更新の API 呼び出し・楽観更新・リバートパターンを共通化。
 * DayListReservations と VehicleList で vehicles の型（map vs array）や
 * 予約連動ロジックが異なるため、state 更新はコールバックで受け取る。
 */
export function useVehicleStatusUpdate({ userId, onOptimisticUpdate, onRevert, onSuccess, onError }: UseVehicleStatusUpdateOptions) {
  const executeStatusUpdate = useCallback(async (vehicle: Vehicle, statusId: any, updates: Partial<Vehicle>) => {
    const updatedVehicle = { ...vehicle, ...updates } as Vehicle;
    onOptimisticUpdate(vehicle, updatedVehicle);

    try {
      await updateVehicle({ id: vehicle.id, ...updates }, userId);
      onSuccess(vehicle, statusId);
    } catch (error) {
      console.error('Failed to update vehicle status:', error);
      onError(vehicle, error);
      onRevert(vehicle);
    }
  }, [userId, onOptimisticUpdate, onRevert, onSuccess, onError]);

  return { executeStatusUpdate };
}
